import { render } from "./Playlists.vue?vue&type=template&id=3ef27bb0"
import script from "./Playlists.vue?vue&type=script&lang=js"
export * from "./Playlists.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__